import React, { useState, useEffect } from 'react';

const MASCOTS = [
  { src: '/mascots/robot.jpg', alt: 'R32 Mascot', flip: true },
  { src: '/mascots/laptop.jpg', alt: 'Laptop', flip: false },
  { src: '/mascots/phone.jpg', alt: 'Telefon', flip: false },
  { src: '/mascots/desktop.jpg', alt: 'Calculator', flip: false },
  { src: '/mascots/case.jpg', alt: 'Husă telefon', flip: false },
  { src: '/mascots/camera.jpg', alt: 'Cameră foto', flip: false },
  { src: '/mascots/headphones.jpg', alt: 'Căști', flip: false },
];

export const RotatingMascot = ({ className = '', interval = 5000 }) => {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % MASCOTS.length);
        setVisible(true);
      }, 350);
    }, interval);
    return () => clearInterval(timer);
  }, [interval]);

  const m = MASCOTS[idx];
  return (
    <img
      src={m.src}
      alt={m.alt}
      data-testid="rotating-mascot"
      className={`${className} object-contain transition-opacity duration-300 ${visible ? 'opacity-100' : 'opacity-0'}`}
      style={m.flip ? { transform: 'scaleX(-1)' } : undefined}
    />
  );
};

export default RotatingMascot;
